import { apiClient } from '@/api/client'
import type {
	SalesSummary,
	OrderStats,
	CustomerStats,
	CommissionStats,
	PendingTasks,
	SalesTrend,
	DepartmentRanking,
	PlatformOverview,
	SupplierProducts,
	SupplierOrders,
	SupplierSettlement,
} from '@/types/dashboard'

export const dashboardApi = {
	// 内部员工卡片
	getSalesSummary: async (): Promise<SalesSummary> => {
		const res = await apiClient.get<SalesSummary>('/dashboard/sales-summary')
		return res.data
	},

	getOrderStats: async (): Promise<OrderStats> => {
		const res = await apiClient.get<OrderStats>('/dashboard/order-stats')
		return res.data
	},

	getCustomerStats: async (): Promise<CustomerStats> => {
		const res = await apiClient.get<CustomerStats>('/dashboard/customer-stats')
		return res.data
	},

	getCommissionStats: async (): Promise<CommissionStats> => {
		const res = await apiClient.get<CommissionStats>('/dashboard/commission-stats')
		return res.data
	},

	getPendingTasks: async (): Promise<PendingTasks> => {
		const res = await apiClient.get<PendingTasks>('/dashboard/pending-tasks')
		return res.data
	},

	getSalesTrend: async (days: number = 7): Promise<SalesTrend> => {
		const res = await apiClient.get<SalesTrend>(`/dashboard/sales-trend?days=${days}`)
		return res.data
	},

	// 超管额外卡片
	getDepartmentRanking: async (): Promise<DepartmentRanking> => {
		const res = await apiClient.get<DepartmentRanking>('/dashboard/department-ranking')
		return res.data
	},

	getPlatformOverview: async (): Promise<PlatformOverview> => {
		const res = await apiClient.get<PlatformOverview>('/dashboard/platform-overview')
		return res.data
	},

	// 供应商卡片
	getSupplierProducts: async (): Promise<SupplierProducts> => {
		const res = await apiClient.get<SupplierProducts>('/dashboard/supplier/products')
		return res.data
	},

	getSupplierOrders: async (): Promise<SupplierOrders> => {
		const res = await apiClient.get<SupplierOrders>('/dashboard/supplier/orders')
		return res.data
	},

	getSupplierSettlement: async (): Promise<SupplierSettlement> => {
		const res = await apiClient.get<SupplierSettlement>('/dashboard/supplier/settlement')
		return res.data
	},
}
